import ConfigurationHelper from "../configuration/ClientConfigurationHelper";

export class Analytics {
    _GA_EVENTS(){
        if(!document.location.hostname.includes("flooranddecor.com")){
            return;
        }
        // https://support.google.com/analytics/answer/11091026?hl=en#zippy=%2Cin-this-article
        // double ga events generated one for UA and second for GA4, this should cover both
        const action  = (arguments[1]?.Event_action ? arguments[1]?.Event_action : arguments[1]?.event_action) || "";
        const category = (arguments[1]?.Event_category ? arguments[1]?.Event_category : arguments[1]?.event_category) || "";
        const label = (arguments[1]?.Event_label ? arguments[1]?.Event_label : arguments[1]?.event_label) || "";
        if(window?.gtag){
            window.gtag("event", category, {
                video_name: label,
                action: action,
                send_to: "G-39EFENHN6Y"
            })
        }
        // ref code send by the client
        if(window?.ga){
            const args = window.ga.getAll();
            for (let i = 0; i < args.length; i++) {
                args[i].send("event", category, action, label);
            }

        }

    }

    productImpresion(product, assetId) {
        this.sendAnalytics("pi", {
            vd: assetId,
            ct: product.id,
            li: ConfigurationHelper.getGlobalConfiguration().loginId,
            pg: ConfigurationHelper.getGlobalConfiguration().channelId
        });
    }

    productClick(product, assetId) {
        this.sendAnalytics("pk", {
            vd: assetId,
            ct: product.id,
            li: ConfigurationHelper.getGlobalConfiguration().loginId,
            pg: ConfigurationHelper.getGlobalConfiguration().channelId
        });

    }
    photoView(asset) {
        if (!asset) return;

        let data = {
            vd: asset.id,
            li: TVSite.loginId
        };
        this.sendAnalytics("pv", data);
    }

    pmEvent(asset) {
        if(!asset) return;
        this.sendAnalytics("pm", {
            li: TVSite.loginId,
            vd: asset.id,
            ui: asset.user_id,
            vti: 0
        });
    }

    sendAnalytics(type, data) {
        if ("_tvpa" in window) {
            _tvpa.push(["track", type, data]);
        }
    }
}

export default new Analytics();
